module.exports = __webpack_public_path__ + "media/images/badges/bft/milestone-500-inactive-bft-ea7a076cb2db0af1d7ab2f5916b7a2b9.png";